// extracted by mini-css-extract-plugin
export default {"PaymentArea":"Payment_PaymentArea__B3tUW","Title":"Payment_Title__v0p33","CheckboxLeft":"Payment_CheckboxLeft__n2BDP","CheckboxRight":"Payment_CheckboxRight__UUcrc"};